"use client";
import { motion } from "motion/react";

interface Props {
  imageIcon?: string;
  backgroundColor?: string;
  children: string;
  shadowColor?: string;
  invert?: boolean;
  // null = no filter active (normal), true = match (glow), false = no match (dim)
  filterMatch?: boolean | null;
}

const SkillIcon = ({
  imageIcon = "/Icons/Template/programming-code-signs-svgrepo-com.svg",
  backgroundColor = "--background",
  children,
  shadowColor = "transparent",
  invert = false,
  filterMatch = null,
}: Props) => {
  var imgClassName = "flex-none h-7 pl-0.5";
  if (
    imageIcon == "/Icons/Template/programming-code-signs-svgrepo-com.svg" ||
    invert
  ) {
    imgClassName = imgClassName + " skill-icon-invert";
  }

  const baseShadow = `0px 0px 0px ${shadowColor}, inset 0px 0px 12px ${shadowColor}`;
  const glowShadow = `0px 0px 18px 4px var(--filter-glow-color)${shadowColor !== "transparent" ? `, 0px 0px 6px ${shadowColor}` : ""}`;

  return (
    <motion.div
      style={{
        backgroundColor: `var(${backgroundColor})`,
        transform: "translateZ(40px)",
        opacity: filterMatch === false ? 0.25 : 1,
        boxShadow: filterMatch === true ? glowShadow : baseShadow,
        transition: "opacity 0.5s ease-out, box-shadow 0.5s ease-out",
      }}
      initial={{ scale: 1 }}
      whileHover={{
        boxShadow: `0px 0px 6px ${shadowColor}, inset 0px 0px 12px ${shadowColor}`,
        scale: 1.1,
      }}
      transition={{
        type: "spring",
        duration: 0.7,
        stiffness: 150,
        damping: 20,
      }}
      className={`inline-flex justify-evenly items-center p-0.5 mx-1 my-0.5 rounded-[16px]`}
    >
      <img className={imgClassName} src={imageIcon} alt="" />
      <h1 className="p-2 pl-4 text-l text-center whitespace-nowrap">
        {children}
      </h1>
    </motion.div>
  );
};

export default SkillIcon;
